module.exports = __webpack_public_path__ + "img/gs-115.78c89dc4.png";